import { Card, Button, Empty, Modal } from 'antd'
import { Project } from '@pindd/types'
import { Trash2 } from 'lucide-react'

interface ProjectListProps {
  projects: Project[]
  onSelect: (project: Project) => void
  onDelete: (id: string) => void
}

export function ProjectList({ projects, onSelect, onDelete }: ProjectListProps) {
  if (projects.length === 0) {
    return <Empty description="暂无项目" />
  }

  const handleDelete = (e: React.MouseEvent, projectId: string, projectName: string) => {
    e.stopPropagation()
    Modal.confirm({
      title: '确认删除',
      content: `确定要删除项目「${projectName}」吗？此操作不可撤销。`,
      okText: '删除',
      cancelText: '取消',
      okButtonProps: { danger: true },
      onOk: () => onDelete(projectId),
    })
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {projects.map((project) => (
        <Card
          key={project.id}
          title={project.name}
          extra={
            <Button
              type="text"
              danger
              icon={<Trash2 className="h-4 w-4" />}
              onClick={(e) => handleDelete(e, project.id, project.name)}
            />
          }
          hoverable
          onClick={() => onSelect(project)}
          className="cursor-pointer"
        >
          <p className="text-sm text-muted-foreground">
            创建时间：{new Date(project.createdAt).toLocaleDateString()}
          </p>
          <p className="text-sm text-muted-foreground">
            画板：{project.boardSize?.name || '未选择'}
          </p>
        </Card>
      ))}
    </div>
  )
}
